import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, ICDConfig } from '../types/config';

export default ((state = {
  enabled: false,
  mapping: {
  },
  constants: {
  },
}, action: ActionObject): ICDConfig => {
  switch (action.type) {
    case ActionTypes.CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<ICDConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/codat/reducers/config.ts